import classNames from 'classnames';
import * as React from 'react';
import {defineMessages, FormattedMessage, useIntl} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {ConfigObjectType} from 'src/js/common';
import {TranslateUtils} from 'src/js/common/utils';

import styles from './LoginMenu.less';

const I18N = defineMessages({
  LOGOUT_BUTTON: {
    id: 'login.button.logout',
    defaultMessage: 'Logout',
    description: 'text for logout button',
  },
  USER_SETTINGS: {
    id: 'login.userSettings',
    defaultMessage: 'User settings',
    description: 'text for user settings link',
  },
});

type Props = {
  isLoggedIn?: boolean;
  config: ConfigObjectType;
  handleLogout: () => void;
  user: string;
};
export const LoginMenu: React.FC<Props> = (props) => {
  const intl = useIntl();
  const {config, isLoggedIn = false, user = ''} = props;

  const handleLogoutClick = (event) => {
    const {handleLogout} = props;
    event.stopPropagation();
    handleLogout();
  };

  const handleLogoutKeyDown = (event) => {
    const {handleLogout} = props;
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      handleLogout();
    }
    return true;
  };
  return (
    <div className={styles.dlLoginMenu}>
      <i
        className={classNames({
          'fas fa-fw fa-1x': true,
          'fa-user': isLoggedIn,
          'fa-user-times': !isLoggedIn,
        })}
      />
      <span className={styles.dlUsername}>{user}</span>
      {/* <i className={'fas fa-angle-down fa-fw fa-1x'} /> */}
      {isLoggedIn ? (
        <span>
          <NavLink
            tabIndex={0}
            title={TranslateUtils.translate(I18N.USER_SETTINGS, intl)}
            to={'/settings'}
            className={styles.dlUserSettingsLink}
          >
            <i className={'fas fa-cog'} />
            <span className={styles.dlUserSettingsLinkText}>
              {TranslateUtils.translate(I18N.USER_SETTINGS, intl)}
            </span>
          </NavLink>

          <span
            className={styles.dlLogoutButton}
            onClick={handleLogoutClick}
            onKeyDown={handleLogoutKeyDown}
            title={TranslateUtils.translate(I18N.LOGOUT_BUTTON, intl)}
          >
            <i
              tabIndex={0}
              role={'button'}
              className={classNames({
                'fas fa-fw fa-1x': true,
                'fa-sign-out-alt': true,
                [styles.dlLogoutIcon]: true,
              })}
            />
            <FormattedMessage {...I18N.LOGOUT_BUTTON} />
          </span>
        </span>
      ) : null}
    </div>
  );
};
